import { Menu, MenuItem, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import {
    resetGetAllTherapyTemplates
} from 'src/redux/actions/therapyPlanning';
import { CopySelectedTempIcon, WeeklyCopyIcon } from './commonComponent/therapy-planning-icons';

type Props = {
    anchorEl: any;
    handleCloseTemplateMenu: any;
    open: boolean;
    setOpenTemplate: any;
    setApplyTemplate: any;
    setAnchorEl: any
};

const TherapyPlanningTemplateMenu = (props: Props) => {
    const dispatch = useDispatch();
    const { anchorEl, handleCloseTemplateMenu, open, setOpenTemplate, setApplyTemplate, setAnchorEl } = props;

    return (
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseTemplateMenu}
            MenuListProps={{
                'aria-labelledby': 'basic-button',
            }}
        >
            <MenuItem
                sx={{ fontWeight: '500', color: '#6C737F' }}
                onClick={() => {
                    setOpenTemplate(true);
                    setAnchorEl(null)
                }}
            >
                {' '}
                <WeeklyCopyIcon />
                <Typography variant="caption">Copy weekly plan</Typography>
            </MenuItem>
            <MenuItem
                sx={{ fontWeight: '500', color: '#6C737F' }}
                onClick={() => {
                    dispatch(resetGetAllTherapyTemplates());
                    setApplyTemplate(true);
                    setAnchorEl(null)
                }}
            >
                {' '}
                <CopySelectedTempIcon />
                <Typography variant="caption">Select a template</Typography>
            </MenuItem>
        </Menu>
    );
};

export default TherapyPlanningTemplateMenu;
